import InnerComponent from '@Components/Sales/CreditNote';
import orgContainer from '@Components/AppContainer';

const ListCreditNote = () => ((orgContainer(InnerComponent)));
export default ListCreditNote;
